import React from 'react';
import PropTypes from 'prop-types';
import { Input } from 'antd';
import Text from '../../../shared/components/basic/Text';
import { Flex } from '../../../shared/components';

export default function DiametrosBar({
  diametro, modo, setDiametroMinimo, parametrosMonturaEsablecidos, permisos,
}) {
  const diametroFijo = permisos && permisos.configuracion.micatalogo_verdatosmontura === 'T';
  const debeUsardiametroMontura = permisos && permisos.configuracion.micatalogo_obligarmontura === 'T';
  const modoConsulta = modo === 'consulta' || !parametrosMonturaEsablecidos || !diametroFijo;
  const handleDiametroMinimoChange = (value) => {
    const isPositiveInteger = /^[1-9]\d*$/.test(value);
    if (isPositiveInteger || value === '') setDiametroMinimo(value);
  };
  return (
    <Flex alignItems={modoConsulta ? 'center' : 'baseline'}>
      <Text>
        Diametro mínimo: &nbsp;
        {!modoConsulta && diametro}
      </Text>
      {modoConsulta
      && (
      <Input
        style={{ width: 58 }}
        size="small"
        value={diametro || ''}
        onChange={({ target: { value } }) => handleDiametroMinimoChange(value)}
        onBlur={({ target: { value } }) => value === '' && setDiametroMinimo(1)}
      />
      )}
    </Flex>
  );
}

DiametrosBar.propTypes = {
  setDiametroMinimo: PropTypes.func,
  diametro: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  modo: PropTypes.string,
  parametrosMonturaEsablecidos: PropTypes.bool,
};

DiametrosBar.defaultProps = {
  setDiametroMinimo: () => {},
  diametro: null,
  parametrosMonturaEsablecidos: false,
  modo: 'consulta',
};
